import React, { useState } from 'react';
import { ButtonGroup, Col, Row } from 'reactstrap';
import { Button } from 'edozvola-frontend-lib/dist/ui';
import { TooltipWrapper } from 'edozvola-frontend-lib/dist/ui/components/tooltipwrapper';
import ViewTable from 'app/shared/view-table/view-table';
import { getPaginationFilter, paginationKeys } from 'app/shared/util/pagination.constants';
import ViewTableHeaderColumn from 'app/shared/view-table/view-table-header-column';
import { isEqual } from 'lodash';
import {
  initialPublicAuthorityFilterValues,
  PublicAuthorityOverviewFilterModel,
  PublicAuthorityOverviewRow,
} from 'app/edozvola/public-authority-overview/model/public-authority-overview.model';
import { PublicAuthorityFilterModal } from 'app/edozvola/public-authority-overview/public-authority-filter-modal';
import {
  fetchPublicAuthorityOverviewQuery
} from 'app/edozvola/public-authority-overview/service/public-authority-overview.queries';


const PublicAuthorityOverview = () => {

  const [publicAuthorityFilter, setPublicAuthorityFilter] = useState<PublicAuthorityOverviewFilterModel>(
    getPaginationFilter(paginationKeys.PUBLIC_AUTHORITY_OVERVIEW) || initialPublicAuthorityFilterValues,
  );
  const [publicAuthorityFilterShown, setPublicAuthorityFilterShown] = useState<boolean>(false);

  const renderTableRow = (value: PublicAuthorityOverviewRow) => {
    return (
      <tr key={value.idPublicAuthority}>
        <td>{value.publicAuthority}</td>
        <td>{value.oib}</td>
        <td>{value.affiliations}</td>
        <td>{value.address}</td>
      </tr>
    );
  };

  const filterActive = () => {
    return !isEqual(publicAuthorityFilter, initialPublicAuthorityFilterValues);
  };

  const resetFilter = () => {
    setPublicAuthorityFilter(initialPublicAuthorityFilterValues);
    localStorage.removeItem(`${paginationKeys.PUBLIC_AUTHORITY_OVERVIEW}-filter-form`);
  };

  return (
    <div className={'container-fluid view-container'}>
      <h3>Javnopravna tijela</h3>
      <Row className={'mt-4'}>
        <Col>
          {!filterActive() && (
            <ButtonGroup>
              <Button
                className={'btn-full-width'}
                prependIcon={'filter'}
                size={'lg'}
                color={'primary'}
                label="Filteri"
                onClick={e => {
                  setPublicAuthorityFilterShown(true);
                  e.currentTarget.blur();
                }}
              ></Button>
            </ButtonGroup>
          )}
          {filterActive() && (
            <div className={'custom-btn-group'}>
              <Button
                className={'btn-group-first-button btn-primary-width'}
                prependIcon={'filter'}
                color={'info'}
                size={'lg'}
                label="Filteri"
                onClick={e => {
                  setPublicAuthorityFilterShown(true);
                  e.currentTarget.blur();
                }}
              ></Button>
              <TooltipWrapper message={'Poništi filtere'}>
                <Button
                  className={'btn-group-last-button btn-secondary-width'}
                  prependIcon={'xmark'}
                  color={'info'}
                  size={'lg'}
                  label=" "
                  onClick={e => {
                    resetFilter();
                    e.currentTarget.blur();
                  }}
                ></Button>
              </TooltipWrapper>
            </div>
          )}
        </Col>
      </Row>
      <Row className={'mt-4'}>
        <Col>
          <ViewTable
            renderTableRow={renderTableRow}
            fetchDataQuery={fetchPublicAuthorityOverviewQuery}
            fetchDataProps={publicAuthorityFilter}
            noDataMessage={'Nema javnopravnih tijela koji odgovaraju unesenim parametrima.'}
            localStorageKey={paginationKeys.PUBLIC_AUTHORITY_OVERVIEW}
            initialPaginationColumn={'publicAuthority'}
          >
            <ViewTableHeaderColumn renderSort={false} columnLabels={['Javnopravno tijelo']} />
            <ViewTableHeaderColumn renderSort={false} columnLabels={['OIB']} />
            <ViewTableHeaderColumn renderSort={false} columnLabels={['Područje nadležnosti']} />
            <ViewTableHeaderColumn renderSort={false} columnLabels={['Adresa']} />
          </ViewTable>
        </Col>
      </Row>
      <PublicAuthorityFilterModal
        filterForm={publicAuthorityFilter}
        setFilterForm={setPublicAuthorityFilter}
        modal={publicAuthorityFilterShown}
        closeModal={setPublicAuthorityFilterShown}
      />
    </div>
  );
}

export default PublicAuthorityOverview;
